import { ReactNode } from 'react';

export enum PortalNameType {
  ADVISOR = 'advisor',
  RETAIL = 'retail',
}

export interface INavDataType {
  label: string;
  path: string;
  icon: () => ReactNode;
}
